<template>
  <!--  TODO: Fill page -->
  <div />
</template>

<script>

    import {mapMutations} from 'vuex'
    import Me from "@/mixins/Me";

    export default {
        name: "Home",

        mixins: [
            Me
        ],

        mounted() {
            this.awaitPromiseCallback({
                key: 'getMe', cb: () => {
                    if (this.$route.name === 'Home' && this.me.id) {
                        this.$router.replace({name: 'UserAccount', params: {userId: this.me.id}})
                    }
                }
            })
        },

        methods: {
            ...mapMutations([
                'awaitPromiseCallback'
            ]),
        },
    }
</script>

<style scoped>

</style>
